import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import useZipCodeCities from "shared/hooks/useZipCodeCities";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import {
  bindInputProps,
  bindWebTextFieldInputProps,
} from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import Select from "../Components/Select";
import validation from "./validation";

function View({ telecoms, onNext, onBack }) {
  const { t } = useTranslation();

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: { telecoms },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  const zipCode = get(
    values,
    `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
  );
  const { cities, loading: citiesLoading } = useZipCodeCities(zipCode);

  return (
    <Layout>
      <Header
        title="Pourriez-vous indiquer votre <b>adresse complète ?</b>"
        highlight="indiquer votre"
        subtitle="Votre localisation"
        onBack={onBack}
      />
      <Row justify="center">
        <Col xs={24} md={18}>
          <div className="grid--2 pb-16">
            <Input
              placeholder={"Numéro et voie"}
              label={"Numéro et voie"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`,
                values,
                setFieldValue,
                ...formProps,
              })}
            />
            <Input
              placeholder={"Lieu – Dit"}
              label={"Lieu – Dit"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS_LOCATION}.value`,
                values,
                setFieldValue,
                ...formProps,
              })}
              optional
            />
          </div>
          <div className="grid--2 pb-16">
            <Input
              placeholder={"ex : 69001"}
              maxLength={5}
              label={"Code postal"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                values,
                ...formProps,
              })}
              onChange={({ target: { value } }) => {
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.CITY}.value`,
                  null,
                );
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                  value,
                );
              }}
            />
            <Select
              showSearch
              loading={citiesLoading}
              options={cities}
              placeholder={"Sélectionnez ..."}
              label={"Ville"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.CITY}.value`,
                values,
                ...formProps,
              })}
            />
          </div>
          <div className="grid--2">
            <Input
              placeholder={"Appartement / étage"}
              label={"Appartement / étage"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.COMPLEMENT}.value`,
                values,
                setFieldValue,
                ...formProps,
              })}
              optional
            />
            <Input
              placeholder={"Résidence / Bâtiment"}
              label={"Résidence / Bâtiment"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.RESIDENCE}.value`,
                values,
                setFieldValue,
                ...formProps,
              })}
              optional
            />
          </div>
        </Col>
      </Row>

      <ActionButtons
        disabled={
          !get(values, `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`) ||
          !isEmpty(formProps.errors)
        }
        onNext={handleSubmit}
        onBack={onBack}
        buttonText="Continuer"
      />
    </Layout>
  );
}

export default View;
